"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var d3 = _interopRequireWildcard(require("d3"));

var _core = require("@emotion/core");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PolygonPreview = function PolygonPreview(_ref) {
  var feature = _ref.feature,
      svgCss = _ref.svgCss,
      svgWidth = _ref.svgWidth,
      svgHeight = _ref.svgHeight,
      stroke = _ref.stroke,
      strokeWidth = _ref.strokeWidth,
      fill = _ref.fill,
      fillOpacity = _ref.fillOpacity,
      padding = _ref.padding,
      reflectY = _ref.reflectY;
  var projection = d3.geoIdentity().reflectY(reflectY).fitExtent([[padding, padding], [svgWidth - padding, svgHeight - padding]], feature);
  var background = d3.geoPath().projection(projection)(feature);
  return (0, _core.jsx)(_react.Fragment, null, (0, _core.jsx)("svg", {
    viewBox: "0 0 ".concat(svgWidth, " ").concat(svgHeight),
    css: svgCss
  }, (0, _core.jsx)("path", {
    d: background,
    stroke: stroke,
    strokeWidth: strokeWidth,
    fill: fill,
    fillOpacity: fillOpacity
  })));
};

PolygonPreview.propTypes = {
  feature: _propTypes["default"].shape({
    type: _propTypes["default"].string
  }),
  svgCss: _propTypes["default"].shape({}),
  svgWidth: _propTypes["default"].number,
  svgHeight: _propTypes["default"].number,
  stroke: _propTypes["default"].string,
  strokeWidth: _propTypes["default"].number,
  fill: _propTypes["default"].string,
  fillOpacity: _propTypes["default"].number,
  padding: _propTypes["default"].number,
  reflectY: _propTypes["default"].bool
};
PolygonPreview.defaultProps = {
  svgWidth: 650,
  svgHeight: 350,
  stroke: "#000000",
  strokeWidth: 1,
  fill: "#000000",
  fillOpacity: 0,
  padding: 5,
  reflectY: true
};
PolygonPreview.displayName = "PolygonPreview";
var _default = PolygonPreview;
exports["default"] = _default;